import { useState } from "react";
import { Bars3Icon } from "@heroicons/react/20/solid";
import { type MenuLink } from "./HeaderButton";
import MobileHeaderMenu from "./MobileHeaderMenu";

type Props = {
  links: MenuLink[];
};

function MobileHeader({ links }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="p-2 hover:bg-primary/10 rounded-lg transition-colors"
      >
        <Bars3Icon className="h-5 w-5" />
      </button>
      <MobileHeaderMenu
        links={links}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}

export default MobileHeader; 